import { AgencySettings_VehicleTypesEnum, HopOnVehicle_StatusEnum } from 'src/api/gen'
import { GranularityEnum } from 'src/commons/types'

export const ORDERED_GRANULARITIES = [
  GranularityEnum.quarter,
  GranularityEnum.month,
  GranularityEnum.week,
  GranularityEnum.day,
  GranularityEnum.hour,
]

export const ORDERED_DEVICE_CATEGORIES = [
  AgencySettings_VehicleTypesEnum.bicycle,
  AgencySettings_VehicleTypesEnum.car,
  AgencySettings_VehicleTypesEnum.delivery_bot,
  AgencySettings_VehicleTypesEnum.moped,
  AgencySettings_VehicleTypesEnum.scooter,
  AgencySettings_VehicleTypesEnum.cargo_bicycle,
  AgencySettings_VehicleTypesEnum.other,
] as AgencySettings_VehicleTypesEnum[]

export const ORDERED_HOPON_VEHICLE_STATUS = [
  HopOnVehicle_StatusEnum.AVAILABLE,
  HopOnVehicle_StatusEnum.DAMAGED,
  HopOnVehicle_StatusEnum.LOST,
  HopOnVehicle_StatusEnum.LOW_BATTERY,
  HopOnVehicle_StatusEnum.MAINTAINING,
  HopOnVehicle_StatusEnum.MAINTENANCE_PENDING,
  HopOnVehicle_StatusEnum.REPORTED,
  HopOnVehicle_StatusEnum.RESERVED,
  HopOnVehicle_StatusEnum.RUNNING,
]
